// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.746605217',
  revision: '746605217',
  branch: 'develop',
  date: 'Wed, 25 Feb 2026 17:08:16 GMT'
};